import React from "react"
import { KbdGroup } from "../kbd"
import { cn } from "../utils"
import { CommandKbd } from "./command-kbd"

export type CommandShortcutProps = Omit<
  React.ComponentPropsWithoutRef<"span">,
  "children"
> & {
  /**
   * Keys of the shortcut. A multi-key chord (e.g. `["g", "s"]`) renders each
   * key in its own box.
   */
  keys: string[]
}

/**
 * A trailing hint for an item's keyboard shortcut. Each key renders in a small
 * gray box; a chord (key sequence) renders as adjacent boxes — e.g. `g` `s`.
 */
export function CommandShortcut({
  keys,
  className,
  ...props
}: CommandShortcutProps) {
  return (
    <KbdGroup
      className={cn("ml-auto group-data-[selected=true]:hidden", className)}
      {...props}
    >
      {keys.map((key, index) => (
        <React.Fragment key={`${key}-${index}`}>
          {index > 0 && (
            <span className="text-[0.6875rem] leading-4 text-gray-700">
              then
            </span>
          )}
          <CommandKbd>{key}</CommandKbd>
        </React.Fragment>
      ))}
    </KbdGroup>
  )
}

CommandShortcut.displayName = "Command.Shortcut"
